module.exports = __webpack_public_path__ + "media/images/front/centres/office_casablanca-1dd07107b5a6076ee17639d5070edbd8.webp";